import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Modal from '../../../../common/modal/Modal';
import EditAcountingDataModalForm from './EditAcountingDataModalForm';
import { putAcountingData } from '../../../../../actions';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { generateTicketAccountingDataEndpoint } from '../../../../../config/endpoints';
import { POST } from '../../../../../config/permissions';

const EditAcountingDataButton = ({ ticket, dispatchPutAcountingData }) => {
  const [showModal, setShowModal] = useState(false);
  const [body, setBody] = useState(null);

  const onSubmit = (formValues) => {
    const newFormValues = { ...formValues };
    const { business } = ticket.transactions[0];
    if (business) {
      newFormValues.businessId = business.id;
      newFormValues.isBusiness = true;
    } else {
      newFormValues.isBusiness = false;
    }

    if (!newFormValues.voucherCode) {
      newFormValues.voucherCode = null;
    }

    dispatchPutAcountingData(ticket.id, newFormValues);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const getTransaction = (transactionList) => {
    if (transactionList.length === 1) {
      return transactionList[0];
    }

    for (let i = transactionList.length - 1; i >= 0; i -= 1) {
      if (!transactionList[i].creditNoteId) {
        return transactionList[i];
      }
    }

    return transactionList.reduce((max, current) =>
      current.amount > max.amount ? current : max,
    );
  };

  const generateInitialValues = () => {
    const initialValues = {};
    const { transactions, manualPaymentMethod, manualVoucherCode, customer } =
      ticket;
    const transaction = getTransaction(transactions);

    if (transaction) {
      initialValues.newPaymentMethod = {
        value: transaction.paymentMethod.id,
        label: transaction.paymentMethod.name,
        transactionCode: transaction.paymentMethod.transactionCode,
      };

      if (transaction.business) {
        initialValues.newBusinessName = transaction.business.name;
        initialValues.newBusinessTaxId = transaction.business.businessTaxId;
      } else {
        initialValues.idDocumentNumber = customer.idDocumentNumber;
      }
    }

    if (manualPaymentMethod) {
      initialValues.newPaymentMethod = {
        value: manualPaymentMethod.id,
        label: manualPaymentMethod.name,
        transactionCode: manualPaymentMethod.transactionCode,
      };

      if (manualVoucherCode) {
        initialValues.voucherCode = manualVoucherCode;
      }
    }

    return initialValues;
  };

  const handleShowModal = () => {
    const initialValues = generateInitialValues();
    const content = (
      <EditAcountingDataModalForm
        onCancel={handleCloseModal}
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    );
    setBody(content);
    setShowModal(true);
  };

  return (
    <>
      <Button color="light" className="border" onClick={handleShowModal}>
        <i className="fa fa-pencil-square-o" /> Editar Datos Contables
      </Button>
      <Modal
        body={body}
        title="Editar Datos Contables"
        show={showModal}
        onClickCancel={handleCloseModal}
        onClickClose={handleCloseModal}
      />
    </>
  );
};

EditAcountingDataButton.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    transactions: PropTypes.arrayOf(
      PropTypes.shape({
        paymentMethod: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }).isRequired,
        creditNoteId: PropTypes.number,
        business: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          businessTaxId: PropTypes.string,
        }),
      }),
    ).isRequired,
    manualPaymentMethod: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      transactionCode: PropTypes.string,
    }),
    manualVoucherCode: PropTypes.string,
    customer: PropTypes.shape({
      idDocumentNumber: PropTypes.string,
    }),
  }).isRequired,
  dispatchPutAcountingData: PropTypes.func.isRequired,
};

EditAcountingDataButton.defaultProps = {};

export const mapDispatchToProps = {
  dispatchPutAcountingData: putAcountingData,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(EditAcountingDataButton);

export default withEndpointAuthorization({
  url: generateTicketAccountingDataEndpoint(0),
  permissionType: POST,
})(connectedComponent);
